import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  ScreenAccessLogService,
  ScreenCode,
} from 'src/app/shared/services/screen-access-log/screen-access-log.service';

@Component({
  selector: 'app-bloco-tarefas',
  templateUrl: './bloco-tarefas.component.html',
  styleUrls: ['./bloco-tarefas.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class BlocoTarefasComponent {
  @Input() exibirTarefasEmpresa = false;

  @Output() closeTarefas = new EventEmitter<void>();

  private readonly screenAccessLog = inject(ScreenAccessLogService);

  private readonly telasPorRota: Record<string, ScreenCode> = {
    '/empresas/tarefas': 'EMPRESA_TAREFAS',
  };

  constructor(private router: Router) {}

  navigateTo(rota: string): void {
    const tela = this.telasPorRota[rota];
    if (tela) {
      this.screenAccessLog.registrar(tela);
    }

    this.router.navigate([rota]);
    this.closeTarefas.emit();
  }
}